module.exports = __webpack_public_path__ + "static/img/icon6.ad59f13a.png";